import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import TypeService from '@iso/services/SettingsService/ProductService/TypeService';

function* viewType({ id }) {
    try {
        const response = yield call(TypeService.getOne, id);
        yield put(actions.viewTypeSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewTypeFailed(extractError(error)));
    }
}

function* watchViewType() {
    yield takeEvery(
        types.REQUEST_VIEW_TYPE,
        viewType,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewType),
    ]);
}

export default viewSaga;
